import React, {
  useState, useContext, useRef, useCallback, useMemo,
} from 'react';

import { DraggableFlatListContext } from './DraggableFlatListContext';


export const ScrollViewContext = React.createContext({
  contentOffset: { x: 0, y: 0 },
  contentSize: { width: 0, height: 0 },
  layout: { width: 0, height: 0 },
  onContentSizeChange: () => {},
  onScrollLayout: () => {},
  onScroll: () => {},
});

export const { Consumer } = ScrollViewContext;

export const Provider = React.memo(({ children }) => {
  const startedScrollingAtY = useRef(0),
        contentOffset = useRef({ x: 0, y: 0 }),
        [layout, setLayout] = useState({ width: 0, height: 0 }),
        [contentSize, setContentSize] = useState({ width: 0, height: 0 }),
        [isUserScrolling, setIsUserScrolling] = useState(false),
        [isScrolling, setIsScrolling] = useState(false);

  const onMomentumScrollBegin = useCallback(() => {
          startedScrollingAtY.current = contentOffset.y;
          setIsScrolling(false);
        }, []),
        onMomentumScrollEnd = useCallback(() => {
          startedScrollingAtY.current = contentOffset.y;
          setIsScrolling(false);
        }, []),
        onScrollBeginDrag = useCallback(() => {
          startedScrollingAtY.current = contentOffset.y;
        }, []),
        onScrollEndDrag = useCallback(() => {
          setIsScrolling(false);
          startedScrollingAtY.current = contentOffset.y;
        }, []),
        onContentSizeChange = useCallback((width, height) => {
          setContentSize({ width, height });
        }, []),
        onScrollLayout = useCallback(({
          nativeEvent: {
            layout: {
              width, height,
            },
          },
        }) => {
          setLayout({ width, height });
        }, []);

  return useMemo(() => (
    <ScrollViewContext.Provider value={{
      contentOffset,
      contentSize,
      layout,
      isUserScrolling,
      setIsUserScrolling,
      startedScrollingAtY,
      onMomentumScrollBegin,
      onMomentumScrollEnd,
      isScrolling,
      onScrollBeginDrag,
      onScrollEndDrag,
      onContentSizeChange,
      onScrollLayout,
    }}
    >
      {children}
    </ScrollViewContext.Provider>
  ), [children, contentSize, isScrolling, isUserScrolling, layout, onContentSizeChange, onMomentumScrollBegin, onMomentumScrollEnd, onScrollBeginDrag, onScrollEndDrag, onScrollLayout]);
});

export default { Consumer, Provider };
